// extracted by mini-css-extract-plugin
module.exports = {"hoverImage":"ProductCardImage_hoverImage__vdsiA","productImg":"ProductCardImage_productImg___sJL7","withPadding":"ProductCardImage_withPadding__1dgv9"};